import { fetchDataSourcePollData } from '@futrli/shared-services/datasource/api';
import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { queryClient } from '../../../core/queryClient';

/**
 * workspacesDatasourcePollDataQuery
 */
export type FetchDatasourcePollDataResult = Awaited<ReturnType<typeof fetchDataSourcePollData>>;
type WorkspacesDatasourcePollDataQueryOptions = Omit<
  QueryObserverOptions<FetchDatasourcePollDataResult>,
  'queryKey' | 'queryFn'
>;

export const workspacesDatasourcePollDataQueryKey = (datasourceIds: string[]) => [
  'workspaces-datasource-poll-data',
  ...datasourceIds
];

export const workspacesDatasourcePollDataQueryConfig = (
  datasourceIds: string[],
  options?: WorkspacesDatasourcePollDataQueryOptions
): QueryObserverOptions<FetchDatasourcePollDataResult> => ({
  queryKey: workspacesDatasourcePollDataQueryKey(datasourceIds),
  queryFn: () => fetchDataSourcePollData(datasourceIds.map(id => `datasourceId=${id}`).join('&')),
  staleTime: 0, // We don't want to cache this data as it is time sensitive
  enabled: datasourceIds.length > 0, // Only enable the query if there are datasourceIds to fetch
  refetchInterval: 10000, // Poll every 10 seconds
  ...options
});

export const workspacesDatasourcePollDataQuery = (
  datasourceIds: string[],
  options?: WorkspacesDatasourcePollDataQueryOptions
): QueryObserver<FetchDatasourcePollDataResult> =>
  new QueryObserver<FetchDatasourcePollDataResult>(
    queryClient,
    workspacesDatasourcePollDataQueryConfig(datasourceIds, options)
  );
